var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('contact-create-update',{attrs:{"is-create":"","contact-data":{contact: {
      handle: _vm.handle,
      registryType: _vm.registry
    }}},on:{"success":_vm.onSuccess,"dataValidityChanged":_vm.onDataValidityChanged,"cancel":_vm.back}}),_c('v-alert',{directives:[{name:"t",rawName:"v-t",value:('general.invalid.form'),expression:"'general.invalid.form'"}],attrs:{"type":"error","value":_vm.isInvalidDataAlertVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }